import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { colorCombinations } from 'utils/colors';

export const useEmptyDataSettings = () => {
	const { darkMode } = useSelector((state) => state.layout);
	const { t } = useTranslation();

	return {
		emptyData: {
			labels: [t('noRecordsFoundTitle')],
			datasets: [
				{
					data: [1],
					backgroundColor: [darkMode ? 'var(--secondaryColor)' : '#F4F4F4'],
					borderColor: [darkMode ? 'var(--secondaryColor)' : '#F4F4F4']
				}
			]
		}
	};
};

export const chartColors = {
	backgroundColor: colorCombinations.map((element) => element.color),
	borderColor: colorCombinations.map((element) => element.color)
};
